import type { QueryClient } from "@tanstack/react-query";
import { dropinApi } from "@bw/shared/api";
import type { DropInSessionResponse } from "@bw/shared/types/generated";

import { queryKeys } from "../../../common/query/queryClient";

/** Keep an accepted aggregate snapshot and every cached facility session coherent. */
export function reconcileFacilitySessions(
  queryClient: QueryClient,
  sessions: DropInSessionResponse[],
) {
  const byFacility = new Map(
    sessions.map((session) => [session.facility_id, session]),
  );

  for (const [queryKey] of queryClient.getQueriesData({
    queryKey: queryKeys.dropin.sessionAll,
  })) {
    const facilityId = queryKey[2];
    if (typeof facilityId === "string") {
      queryClient.setQueryData(
        queryKey,
        byFacility.get(facilityId) ?? null,
      );
    }
  }

  for (const session of sessions) {
    queryClient.setQueryData(
      queryKeys.dropin.session(session.facility_id),
      session,
    );
  }
}

export function currentDropInSessionsQueryOptions() {
  return {
    queryKey: queryKeys.dropin.currentSessions(),
    queryFn: (): Promise<DropInSessionResponse[]> =>
      dropinApi.listCurrentSessions(),
    staleTime: 0,
  };
}
